import React, { useContext } from 'react'
import { Context } from './Context'
import { NavData } from '../wbstdt/Wbstdt'

export default function NotFound() {

    const { lang } = useContext(Context)

    return (
        <div style={{ width: '100vw', height: '100vh' }} className="flex-container-centered">
            <div style={{textAlign: "center"}}>
                <img src={NavData.logo} alt="" />
                <h3 className="title">{lang === 'fr' ? "Page pas trouvée" : "Page not found"} <br/>404</h3>
                <button className="btn btn-small btn-normal-enabled" onClick={() => window.location = '/'}>{lang === 'fr' ? "Retourner au site principal" : "Get back home"}</button>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/Component/NotFound.js